
import { KoButton, KoDate, KoForm, KoFormBuilder, KoModal, KoNano, KoSelect, KoTextArea, KoToast, KoUpload, KoUserSelect} from 'packages';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './expenses.module.scss';
import { useSelector } from 'react-redux';
import { getCookie } from 'shared/utils/cookies';
import Driver from 'packages/drivers';
import KoIcon from '@kwapio/icons';
import { InboxAPI } from '../inbox.service';
import { CURRENCY } from 'pages/admin/settings/details/curd/constant';

export default function ExpensesCurd({form, handleFinish, initialValues}) {
  const users = useSelector(state => state?.users);
  const holidays = useSelector(state => state?.holidays);

  const [, setLoading] = useState(false);
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [lookupId ] = useState(KoNano('LOK'));
  const [workspaceList, setWorkspaceList ] = useState([]);
  const [categoryList,setCategoryList]=useState([]);
  const [, setCurrentFile] = useState();
  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const Managers = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} mode="multiple" users={users['data']} placeholder='Select Team Members' />;

  const ManagersA = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={users['data']} placeholder='Select Team Members' />;

  useEffect(()=>{
    getWorkspaceList();
    getCategoryList();
  },[]);

  const getCategoryList = async() => {
    try {
      const res = await InboxAPI.getCategoryList();
      const list = Array.isArray(res?.category) ? res.category : [];
      setCategoryList(list);
    } catch (error) {
      console.log("Error Fetching Category List:", error);
    }
  };

  const CategoryList = ({ value, onChange }) => (
    <KoSelect
      placeholder="Select CategoryList"
      showSearch
      mode="single"
      value={value}
      optionFilterProp="searchText"
      filterOption={(input, option) => {
        const text = option.searchText?.toLowerCase() || "";
        return text.includes(input.toLowerCase());
      }}
      onChange={(v) => onChange(v)}
      options={categoryList.map((category) => ({
        label: `${category.name}`,
        value: category.name,
        searchText: `${category.name}`
      }))}

    />
  );

  const getWorkspaceList = async() => {
    try {
      const res = await InboxAPI.getWorkspaceList();
      setWorkspaceList(res['workspaces']);
    } catch (error) {
      console.error('Error fetching workflows:', error);
    }
  };

  const WorkspaceList = ({ value, onChange }) => (
    <KoSelect
      placeholder="Select Project"
      showSearch
      mode="single"
      value={value}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
      onChange={(v) => {onChange(v);}}
      options={workspaceList?.map((workspace) => ({
        label: `${workspace?.name}`,
        value: workspace?.name
      }))}
    />
  );
  const Date = ({ value, onChange }) =>
    <KoDate value={value} format = {'DD-MMM-YYYY'}
      holidays={holidays['data']}
      onChange={v => onChange(v)} />;
    
  // const Attachments = ({ value, onChange }) =>
  //   <KoUpload
  //     isDnd={true}
  //     listType="picture"
  //   >
  //     <div className={styles.upload}>
  //       <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
  //       <p className="ant-upload-hint">
  //                 Support for single or bulk uploads. Uploading banned files is strictly prohibited.
  //       </p>
  //     </div>
  //   </KoUpload>;



  const currencyFormat = ({ value, onChange }) =>

    <KoSelect value={value}
      showSearch
      placeholder='Select currency format'
      onChange={v => onChange(v)}
      options={CURRENCY} />;

  const props ={
    name: 'files',
    multiple: true,
    maxCount: 1,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { service:'admin', module:'expense', lookupId: lookupId },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
      }
      const { fileList } = info;

      const allFinished = fileList.every(
        file => file.status === 'done' || file.status === 'error'
      );

      if (allFinished) {
        setLoading(true);

        const successfulFiles = fileList
          .filter(file => file.status === 'done')
          .map(file => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            response:file.response,
            lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
          }));
        form.setFieldsValue({ attachments: successfulFiles });
        setLoading(false);
      }
      else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields:  [
      { key: "expenseTitle", label: "Expense Title",  colSpan: 4, placeholder: 'Enter expense title' ,rules: [
        {
          required: true,
          message: `Please enter expense title.`
        }
      ]},
      { key: "category", label: "Category", widget: CategoryList , colSpan: 2, rules: [
        {
          required: true,
          message: `Please select category.`
        }
      ]},
      { key: "expenseDate", label: "Expense Date", widget: Date, colSpan: 2,rules: [
        {
          required: true,
          message: `Please enter expense date.`
        }
      ] },
      { key: "costCenter", label: "Project / Team / Cost Center",  colSpan: 2,  widget: WorkspaceList },
      {
        key: 'approver', label: 'Approver', colSpan: 2,
        widget: ManagersA,
        rules: [
          {
            required: true,
            message: `Please select approver.`
          }
        ]
      },
      { key: "currency", label: "Currency",  colSpan: 2, widget: currencyFormat },
      { key: "amount", label: "Amount", widget: "number", colSpan: 2, rules: [
        {
          required: true,
          message: `Please enter amount.`
        }
      ]},
      { key: "attachments", label: "Receipts",  colSpan: 4, className: 'metaFieldHide' },
      { key: "status", label: "Status", colSpan: 2, className: 'metaFieldHide'},
      {
        key: 'notify', label: 'Notify', colSpan: 4,
        widget: Managers
      },
      {  key: 'comment', widget: KoTextArea, label: 'Comment', colSpan: 6, placeholder: 'Enter comment' }
    ]
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handleSubmit = useCallback((values) => {
    handleFinish(values);
  });
  
  // const handleSubmit = useCallback(values => {
  //   values['attachments']=normFile;
  //   handleFinish(values);
  // });


  // const removePrefix = (type, prefix) => {
  //   return type.startsWith(prefix) ? type.substring(prefix.length) : type;
  // };
  // const uploadButton = (
  //   <div className={styles.dndArea}>
  //     {isLoading && <KoLoader size='small'/>}
  //     <KoIcon name='AttachmentOutlined'/>
  //     <div>Add image, video, or file</div>
  //   </div>
    
  // );

  return (
    <div className={styles.wrapperCurd}>
      <div className={styles.uploadWrapper}>
        {/* <Driver fileType={'application/pdf'} filePath={'https://storage.googleapis.com/kwapio_attachments/acc219cf99ae4/file/root/Kaliyappan%20milk%20dairy.pdf?Expires=1763905122&GoogleAccessId=kwapio-service-account%40kapio-service.iam.gserviceaccount.com&Signature=DYP3Vtr5H9KrB0DaUZEX0xfW33NdcdolbpdXCHkbS4reAqTAcUKm14bcANvdZiOVE1lDWdmxVp%2FosS4U8HGLYrr%2FXoSfjxYb%2FQCkqwUmu%2FmqztgHddP2Bfp3Qq6jy6%2F%2BjnsZ81Maw6FL%2F6THBBk2ISMztvJWBVSxZeVSCFNLjjpXJjXEDBFaNYDRccJadvNn0AG%2BWoPg3Hnfrk9FS7F8OsA3poapf5Xsrd0g5lqN1tnydrflNjeErw0P04Lw1Bsr0pLdTGRJdvye56QhvKoPIzt87vpohrnCwsxM89G83mjFDW3IDZp%2FpmFE84k4s7Ybg0agrTgPIcDtBstydrXmOg%3D%3D'} /> */}

        {initialValues?.attachments?.map((att) =>
          <div key={'attachments'} className={styles.attachmentsArea}>
            <Driver action={true} fileType={'application/pdf'}  filePath={props} />
            {/* 
            <Driver  fileType={'application/pdf'}   filePath={fileDetails?.url} /> */}
          </div>
        )}
        {/* <KoForm.Item
          name={["attachments"]}
          valuePropName={["attachments"]}
          getValueFromEvent={normFile}>

          <Upload {...props}
            showUploadList={false}
            showPreviewIcon={false}
            listType="picture-card"
            multiple={true}
          >
            {uploadButton}
          </Upload>
        </KoForm.Item> */}
      </div>
      <div className={styles.formWrapper}>
        <KoForm form={form} layout="vertical"
          onFinish={handleSubmit} onSubmit={handleSubmit}
        >
          <KoFormBuilder form={form} meta={meta} />
        </KoForm>
        <div className={styles.btnWrapper}>
          <KoButton onClick={()=>setUploadFileModal(true)} type="primary" label={'Upload Receipts'} icon={<KoIcon color="#FFF" width={14} height={14} name={'AttachmentOutlined'} />} />
        </div>
      </div>
      <KoModal
        title={'Upload File'}
        centered
        open={uploadFileModal}
        afterClose={() => { setCurrentFile(); }}
        handleOk={() => { setUploadFileModal(false); }}
        onClose={() => { setUploadFileModal(false); }}
        width={760}
        footer={[]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {/* {isLoading && <KoLoader circle={false} />} */}
          <KoForm.Item
            name={["attachments"]}
            valuePropName={["attachments"]}
            getValueFromEvent={normFile}>
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
                <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </KoForm.Item>
        </div>
      </KoModal>
    </div>
  );
}

